import React, { useEffect, useState } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Nav } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import './NavMenu.css';
import CustomContextMenu from './context-menu';
import { useTranslation } from 'react-i18next';

export const NavMenu = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [isRequestPage, setIsRequestPage] = useState(false)
  const location = useLocation();
  const {t} = useTranslation();


  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    setIsRequestPage(location.pathname.includes('requests/create') || location.pathname.includes('register'));
  }, [location]);

  return (
    <header className="sticky-header">
    <Navbar expand="md" className={`navbar-expand-md navbar-toggleable-md box-shadow`} container dark>
      <div className="navbar-header-container">
        <NavbarBrand className="navbar-brand" tag={Link} to="/">
        <img
                src={require('../assets/mvp-logo.png')}
                alt="DLP Logo"
                style={{ height: "auto", width:"100px"}} // Adjust size to match `text-[46px]`
              />
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
      </div>
      <Collapse className="d-md-inline-flex flex-md-row" isOpen={!collapsed} navbar>
        <div className='nav-div'>
          <Nav className='nav-list'>
            <NavItem className='nav-item'>
              <NavLink href="/" className={`nav-link ${location.pathname === '/' && 'active'}`}>
                {t("navbar:navigation-options:home", "Home")}
              </NavLink>
            </NavItem>
          </Nav>
        </div>
        <ul className="navbar-nav flex-grow">
          <NavItem style={{ width: '100%' }}>
            <CustomContextMenu isRequestPage={isRequestPage} />
          </NavItem>
        </ul>
      </Collapse>
    </Navbar>
  </header>
  
  );
};
